module.exports = __webpack_public_path__ + "static/assets/59df3246c738e59356ead7c440db9a74.svg";